"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetIdToOsmosis = exports.osmosisToAssetId = exports.osmosisUrl = void 0;
const adapters = __importStar(require("./generated"));
exports.osmosisUrl = 'https://api-osmosis.imperator.co/tokens/v2/all';
const generatedAssetIdToOsmosisMap = Object.values(adapters).reduce((acc, cur) => ({
    ...acc,
    ...cur,
}));
const invert = (data) => Object.entries(data).reduce((acc, [k, v]) => ((acc[v] = k), acc), {});
const generatedOsmosisToAssetIdMap = invert(generatedAssetIdToOsmosisMap);
const osmosisToAssetId = (id) => generatedOsmosisToAssetIdMap[id];
exports.osmosisToAssetId = osmosisToAssetId;
const assetIdToOsmosis = (assetId) => generatedAssetIdToOsmosisMap[assetId];
exports.assetIdToOsmosis = assetIdToOsmosis;
